// components/Loader.js
import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const Loader = () => (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#ffffff',
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  );

export default Loader;
